import request from "../../request.js"
import qs from "qs";

// 上传文件接口
export  function uploadFileToTxCloudInterview(data) {
	return request({
		url: "/tx-cloud-file/uploadFileToTxCloudInterview",
		method: "POST",
		data
	})
}
// 获取腾讯云秘钥
export  function getPolicyTxCloudInterview(data) {
	return request({
		url: "/tx-cloud-file/getPolicyTxCloudInterview",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 登录
export  function getAjUserExist(data) {
	return request({
		url: "/aj-user-other/getAjUserExist",
		method: "POST",
		data:qs.stringify(data)
	})
}
// 更新头像
export  function updateAjUserHeader(data) {
	return request({
		url: "/aj-user-other/updateAjUserHeader",
		method: "POST",
		data:qs.stringify(data)
	})
}